import { useQueryGetEnabledFeaturesForMyClients } from "../data/services/featureAccessService";
import { hasEnabledFeature } from "./useFeatureAccess";

/**
 * Is a gated feature enabled for *any* client this user can reach?
 *
 * For screens that list clients rather than sitting inside one - the client list
 * dashboard has no single client id, so useFeatureAccess does not apply there.
 * Scoping is server-side from the caller's claims; this hook takes no client id.
 *
 * Fails safe to false on the same terms as useFeatureAccess.
 */
const useAnyClientFeatureAccess = (featureKey, oePeriodId) => {
  const result = useQueryGetEnabledFeaturesForMyClients(oePeriodId);

  return hasEnabledFeature(result, featureKey);
};

export default useAnyClientFeatureAccess;
